import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FylgibrefPrint from "pages/skraning/atkvaedi/components/print/fylgibref/FylgibrefPrint";
import FylgibrefPreview from "pages/skraning/atkvaedi/components/print/fylgibref/FylgibrefPreview";
import UmslagPrint from "pages/skraning/atkvaedi/components/print/umslag/UmslagPrint";
import UmslagPreview from "pages/skraning/atkvaedi/components/print/umslag/UmslagPreview";
import { mockFormState, mockKjosandi, mockActiveKosning } from "common/services/mockService";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  titleSection: {
    textAlign: 'left',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  titleText: {
    textTransform: 'uppercase',
    borderBottom: '3px solid',
    borderBottomColor: theme.palette.primary.main,
  }
}));

const Stillingar = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <div style={{ marginBottom: "16px" }}>
        <Typography
          className={classes.titleSection}
          variant="h5"
          component="h2"
        >
          <strong className={classes.titleText}>Prentun</strong>
        </Typography>
      </div>
      <Grid
        container
        direction="column"
        alignItems="flex-start"
        justify="center"
      >
        <Paper className={classes.paper}>
          <Typography variant="h5" style={{ marginBottom: "16px" }}>
            Prófa prentun
          </Typography>
          <Grid
            container
            direction="row"
            spacing={2}
            alignItems="center"
            justify="center"
          >
            <Grid item>
              <FylgibrefPrint
                formState={mockFormState}
                kjosandi={mockKjosandi}
                activeKosning={mockActiveKosning}
              />
            </Grid>
            <Grid item>
              <UmslagPrint
                kjosandi={mockKjosandi}
                activeKosning={mockActiveKosning}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            spacing={2}
            alignItems="center"
            justify="center"
            style={{ marginTop: "16px" }}
          >
            <Grid item>
              <FylgibrefPreview
                formState={mockFormState}
                kjosandi={mockKjosandi}
                activeKosning={mockActiveKosning}
              />
            </Grid>
            <Grid item>
              <UmslagPreview
                kjosandi={mockKjosandi}
                activeKosning={mockActiveKosning}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ marginTop: "32px" }}
          >
            <Grid item xs>
              <Typography color="textSecondary">
                <strong>
                  Athugið að nauðsynlegt er að velja rétta blaðastærð við
                  prentun
                </strong>
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography color="textSecondary">
                Fylgibréf skal prenta sem <em>A4</em> en umslag sem{" "}
                <em>Envelope B5</em>
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Fragment>
  );
}

export default Stillingar;
